import styles from "./Processos.module.scss"
import NavBar from "../../components/NavBar"
import SectionProcessos from "../../components/Section/SectionProcessos"

export default function Processos() {
    return (
        <main className={styles.principal}>
            <NavBar />
            <div className={styles.container}>
                <h1>Processos</h1>
                <SectionProcessos />
            </div>
        </main>
    )
}